import React, {Component} from 'react';

import {Link} from 'react-router-dom';
import {Navbar, NavItem, NavDropdown, Nav, MenuItem} from 'react-bootstrap';
import './CustomNavbar.css';

export default class CustomNavbar extends Component {

    render() {
        return (

            <Navbar  collapseOnSelect className="navbarr">
                <Navbar.Header>
                    <Navbar.Brand>
                        <a href="/">Açık ve Uzaktan Öğrenme Dijital Yayın Merkezi</a>
                    </Navbar.Brand>
                    <Navbar.Toggle/>
                </Navbar.Header>
                <Navbar.Collapse>
                    <Nav pullRight>
                        <NavItem eventKey={1} href="/about">
                            Hakkımızda
                        </NavItem>
                        <NavItem eventKey={2} href="/contact">
                            İletişim
                        </NavItem>
                    </Nav>
                </Navbar.Collapse>
            </Navbar>


        )
    }

}



// WEBPACK FOOTER //
// ./src/components/CustomNavbar.js